<template>
  <div :title="i18n.title">
    <div v-if="second > 0" class="result-loading-warp">
      <div class="result-loading circle">
        <circle-progress v-model="percent" />
        <span>{{ secondFmt }}s</span>
      </div>
      <div class="result-loading-tips">
        {{ i18n.msg_tips_loading }}
      </div>
    </div>
    <div v-else-if="order" class="result-content">
      <!-- <img class="unlocked" src="../../assets/imgs/img_release.png" alt="" /> -->
      <h2>{{ i18n.rental_success }}</h2>
      <img class="mainbanner" src="../../assets/imgs/img_cabinet.png" alt="" />
      <div class="tips">{{ i18n.tips }}</div>
      <div class="downloadbtn">
        <DownloadApp></DownloadApp>
      </div>
      <div class="result-btns">
        <div class="btn" @click="$router.replace({ path: `/order` })">
          {{ i18n.view_order }}
        </div>
      </div>

      <!-- <div class="downloadbtn" @click="goOrder"><span>{{ i18nMsg.vieworder }}</span></div> -->
    </div>
    <result-msg
      v-else-if="loading"
      type="100"
      :text="i18n.msg_result_loading"
    />
    <result-msg v-else-if="error" type="500" :text="error" @click="onReload" />
    <result-msg v-else />
  </div>
</template>

<script>
import { mapState } from "vuex"
import CircleProgress from "../../components/result/circle_progress.vue"
import ResultMsg from "../../components/result/msg.vue"
import DownloadApp from "@/components/download/downloadApp"
import { ORDER_CHECK } from "../../apis/cabinet.js"
import {
  PAYPAL_EXC_PAY,
  MYFATOORAH_PREAUTH_OF_CONFIRM,
  PAY_CONFIRM
} from "../../apis/payment.js"
let loadingTimer
export default {
  components: {
    ResultMsg,
    CircleProgress,
    DownloadApp
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    paypal(val, oldVal) {
      if (val && val.paymentId) {
        this.onPayExec()
      }
    }
  },
  computed: {
    ...mapState(["cabinet", "system"]),
    i18n() {
      return this.$t("result")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    percent() {
      return (this.second % 30) * 3.334
    },
    secondFmt() {
      return (this.second + 0.45).toFixed(0)
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format(this.order)
    },
    infoTips1() {
      return `${this.i18n.tips_1}`.format(this.order)
    },
    infoTips2() {
      return this.i18n.tips_2
    },
    imgSrc() {
      if (this.order && this.order.shebei) {
        return `${process.env.VUE_APP_DOMAIN}/content/cabinet${this.order.shebei}_${this.order.number}.gif`
      } else {
        return `${process.env.VUE_APP_DOMAIN}/content/img_cabinet.png`
      }
    }
  },
  data() {
    return {
      loading: false,
      error: "",
      paypal: null,
      order: null,
      tradeNo: "",
      second: 0,
      payMode: "paypal",
      downloadApp: false,
      clearCabinet: true
    }
  },
  methods: {
    startTimer() {
      if (this.second === 0) {
        loadingTimer = setInterval(() => {
          this.second += 0.1
        }, 100)
      }
    },
    stopTimer() {
      clearInterval(loadingTimer)
      this.second = 0
    },
    onInput(val) {
      this.$emit("input", val)
    },
    onDownload() {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY
      if (this.system === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE
      }
      if (dowmloadUrl) {
        window.open(dowmloadUrl)
      } else {
        this.$toast(this.i18nMsg.appoffline)
      }
    },
    goOrder() {
      this.$router.replace("/order")
    },
    onReload() {
      if (this.tradeNo) {
        this.checkOrder(this.tradeNo, this.payMode)
      } else {
        this.onPayExec()
      }
    },
    onPayExec() {
      this.startTimer()
      this.loading = true
      this.$post(
        PAYPAL_EXC_PAY,
        {
          ...this.paypal
        },
        (resp) => {
          this.loading = false
          this.error = ""
          const data = resp.data
          if (data.out_trade_no) {
            if (data.pay_type === "CZ") {
              this.$confirm({
                title: this.i18nMsg.title,
                content: this.i18nMsg.success_payment,
                confirmText: this.i18nMsg.confirm,
                showCancel: false
              }).then(() => {
                this.$router.push("/mine")
              })
            }
            if (data.pay_type === "YJ") {
              this.checkOrder(data.out_trade_no)
            }
          }
        },
        (error) => {
          if (this.second < 30) {
            this.onPayExec()
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    checkOrder(tradeNo, payMode = "paypal", payType = "") {
      if (!payType) {
        this.startTimer()
      }
      // if (payMode === 'mpesa') {
      //   this.onSMSCheckOrder(tradeNo, payMode, payType)
      //   return
      // }
      this.tradeNo = tradeNo
      this.loading = true
      this.$post(
        `${ORDER_CHECK}/${tradeNo}/${payMode}`,
        {},
        (resp) => {
          if (payType === "FK") {
            this.$router.replace({ path: `/order` })
          } else if (payType === "CZ") {
            this.$router.replace({ path: "/wallet" })
          }
          this.loading = false
          this.error = ""
          this.order = resp
          this.stopTimer()
        },
        (error) => {
          if (payType === "FK") {
            setTimeout(() => {
              this.$router.replace({ path: `/order` })
            }, 1500)
          } else if (payType === "CZ") {
            setTimeout(() => {
              this.$router.replace({ path: "/wallet" })
            }, 1500)
          } else if (error === "正在请求中" || error === "Processing") {
            setTimeout(() => {
              this.checkOrder(tradeNo, payMode, payType)
            }, 3000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        }
      )
    },
    // 订单支付确认
    onMyfatoorahConfirm(tradeNo = "", outTradeNo = "", type = "") {
      this.startTimer()
      this.loading = true
      const query = { tradeNo: tradeNo, outTradeNo: outTradeNo }
      this.$Request("get", MYFATOORAH_PREAUTH_OF_CONFIRM, query)
        .then((resp) => {
          const data = resp.data
          this.loading = false
          this.error = ""
          if (type === "RENT" && data && data.orderStatus === 1) {
            return this.$router.replace({ path: `/order` })
          } else if (data && data.orderStatus === 0) {
            return (this.error = resp.msg)
          }
          this.stopTimer()
          this.order = resp
        })
        .catch((error) => {
          console.warn("onMyfatoorahConfirm ~ error:", error)
          if (error === "正在请求中" || error === "Processing") {
            setTimeout(() => {
              this.onMyfatoorahConfirm(tradeNo, outTradeNo)
            }, 1000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        })
    },
    onPayConfirm (outTradeNo, payMode) {
      this.startTimer()
      this.loading = true
      const query = { outTradeNo: outTradeNo }
      this.$Request("get", PAY_CONFIRM, query)
        .then((resp) => {
          // RENT
          this.checkOrder(outTradeNo, payMode)
        })
        .catch((error) => {
          if (error === "正在请求中" || error === "Processing") {
            setTimeout(() => {
              this.onPayConfirm(outTradeNo, payMode)
            }, 1000)
          } else {
            this.stopTimer()
            this.loading = false
            this.error = error
            console.log(error)
          }
        })
    }
  },
  created() {
    console.log("result route:", this.$route.query)
    let {
      paymentId,
      outTradeNo,
      type,
      token,
      PayerID,
      tradeNo,
      payMode,
      payType,
      status
    } = this.$route.query
    this.payMode = payMode
    if (payMode.startsWith('Eghl_Pay')) {
      if (status === "success") {
        this.onPayConfirm(outTradeNo, payMode)
      } else if (status === "fail") {
        this.onPayConfirm(outTradeNo, payMode)
      } else {
        this.clearCabinet = false
        this.$router.replace({ path: `/borrow` })
      }
    } else if (!!outTradeNo & !!type) {
      this.onMyfatoorahConfirm(tradeNo, outTradeNo, type)
    } else if (tradeNo) {
      this.checkOrder(tradeNo, payMode, payType)
    } else {
      this.paypal = {
        paymentId,
        token,
        payerId: PayerID
      }
    }
  },
  destroyed() {
    if (this.clearCabinet) {
      this.$store.commit("cabinet", null)
      this.$store.commit("qrcode", "")
    }
  }
}
</script>

<style lang="less">
.result-content {
  min-height: 100vh;
  background-color: #fff;
  background-image: url('../../assets/imgs/app_bg.png');
  background-size: 100%;
  background-repeat: no-repeat;

  .unlocked {
    max-width: 30%;
    display: block;
    margin: 0px auto;
    padding: 50px 0 0;
  }

  h2 {
    font-size: 52px;
    font-weight: bold;
    text-align: center;
    margin: 0;
    padding: 80px 0 52px;
  }

  .mainbanner {
    width: 100%;
    display: block;
    // margin: 0 0 80px;
  }

  .tips {
    font-size: 28px;
    color: #000;
    text-align: center;
    margin: 40px 60px 40px;
  }

  .downloadbtn {
    margin: 0 32px;
  }
}

.result-loading {
  &.circle {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-warp {
    background: #fff;
    padding: 30px 0;
  }

  & span {
    position: absolute;
    font-size: 70px;
    color: #f13453;
  }

  &-tips {
    text-align: center;
    font-size: 28px;
    color: #39FF14;
  }
}
.result-btns {
  padding: 28px 32px;
}
</style>
